import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  text: string;
  href?: string;
  onClick?: () => void;
  className?: string;
  isLink?: boolean;
}
// Track Meta Pixel events on CTA clicks
function trackMetaEvent() {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;
    (window as any).fbq('track', 'InitiateCheckout');
  }
}
export function CTAButton({
  text,
  href = 'https://checkout.guiadigital360.online/cart/44819876446277:1',
  onClick,
  className = '',
  isLink = false
}: CTAButtonProps) {
  const isExternalLink = href.startsWith('http');
  const handleClick = () => {
    trackMetaEvent();
    if (onClick) onClick();
  };
  const baseClasses = `
    inline-block w-full text-center bg-brand-green text-white font-black 
    text-lg md:text-2xl py-4 md:py-5 px-6 rounded-xl 
    shadow-[0_8px_25px_-5px_rgba(0,178,122,0.5)] 
    hover:shadow-[0_12px_30px_-5px_rgba(0,178,122,0.7)] 
    hover:bg-[#009a6a] transition-all duration-300 uppercase tracking-wide
    ${className}
  `;
  const content = <motion.div whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className="relative overflow-hidden" data-id="element-310">
      {/* Shine effect */}
      <div className="absolute top-0 -inset-full h-full w-1/2 z-5 block transform -skew-x-12 bg-gradient-to-r from-transparent to-white opacity-20 animate-[shine_3s_infinite]" data-id="element-311" />
      <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-312">
        {text}
      </span>
    </motion.div>;
  if (isLink) {
    return <a href={href} className={baseClasses} onClick={handleClick} target={isExternalLink ? '_blank' : undefined} rel={isExternalLink ? 'noopener noreferrer' : undefined} data-id="element-313">
        {content}
      </a>;
  }
  return <button onClick={() => {
    handleClick();
    if (!onClick) window.location.href = href;
  }} className={baseClasses} data-id="element-314">
      {content}
    </button>;
}